import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import { LeftMargin1Rem } from 'styles/GlobalStyledComponents';
import issuesService from 'services/issues';

export type tAcceptIssueAction = {
  history: { push: Function };
  actions: { [key: string]: string };
  setNotification: Function;
};

const AcceptIssueAction: React.FC<tAcceptIssueAction> = ({ history, actions, setNotification }) => {
  const { t } = useTranslation();
  const { open } = actions;

  const acceptIssueHandler = async () => {
    try {
      const result = await issuesService.rejectAcceptIssue(open);
      if (result?.status === 200) {
        setNotification(t('Issue was accepted'), 'success');
        history.push('/issues');
      }
    } catch (err) {
      if (err?.status === 409) return setNotification(err.data[0].msg);
      setNotification(t('Something went wrong. Try again'));
    }
  };

  return (
    <LeftMargin1Rem>
      <Button variant='green' onClick={acceptIssueHandler} disabled={!!!open}>
        {t('Accept')}
      </Button>
    </LeftMargin1Rem>
  );
};

export default AcceptIssueAction;
